"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addressesForUser = exports.addressForUser = exports.dummyAppUserProfile = void 0;
exports.dummyAppUserProfile = {
    id: '',
    accountGroups: [{
            addresses: [],
        }],
};
function addressForUser(user) {
    if (!user) {
        return undefined;
    }
    return (user.accountGroups || [])[0].addresses[0] || {};
}
exports.addressForUser = addressForUser;
function addressesForUser(user) {
    if (!user) {
        return [];
    }
    return (user.accountGroups || [])[0].addresses || [];
}
exports.addressesForUser = addressesForUser;
//# sourceMappingURL=AppState.js.map